var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideshow"},[_c(((_vm.data.acf.media) + "-slideshow"),{tag:"component",attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }